import { PdfManagementStore } from "./management/PdfManagementStore";
import { PdfEditorViewStore } from "./editor/PdfEditorViewStore";

const pdfStoreList = [
    { name: 'pdfManagementStore', store: PdfManagementStore },
    { name: 'pdfEditorViewStore', store: PdfEditorViewStore }
];

export default pdfStoreList;
